<!-- dashboard.component.html -->
<div class="app-container">
  <!-- Sidebar: Always render, but styled differently on mobile -->
  <div
    class="sidebar"
    *ngIf="!isSettingsRoute()"
    [class.minimized]="
      (sidebarState$ | async)?.isMinimized &&
      !(sidebarState$ | async)?.isSideBySide &&
      !(sidebarState$ | async)?.isMobile
    "
    [class.expanded]="(sidebarState$ | async)?.isSideBySide && !(sidebarState$ | async)?.isMobile"
    [class.mobile-mode]="(sidebarState$ | async)?.isMobile"
  >
    <app-sidebar></app-sidebar>
  </div>
  <div class="sidebar settings-sidebar-wrapper" *ngIf="isSettingsRoute()">
    <app-settings-sidebar></app-settings-sidebar>
  </div>

  <!-- Mobile Settings Sidebar Overlay -->
  <div
    class="settings-sidebar-mobile"
    *ngIf="isSettingsRoute() && (sidebarState$ | async)?.isMobile && (sidebarState$ | async)?.settingsDrawerOpen"
  >
    <app-settings-sidebar></app-settings-sidebar>
  </div>
  <div
    class="content"
    [class.content-minimized]="
      !isSettingsRoute() &&
      (sidebarState$ | async)?.isMinimized &&
      !(sidebarState$ | async)?.isSideBySide &&
      !(sidebarState$ | async)?.isMobile
    "
    [class.content-expanded]="
      !isSettingsRoute() &&
      (sidebarState$ | async)?.isSideBySide &&
      !(sidebarState$ | async)?.isMobile
    "
    [class.content-mobile]="(sidebarState$ | async)?.isMobile"
    [class.content-settings]="isSettingsRoute()"
    [class.content-settings-mobile]="isSettingsRoute() && (sidebarState$ | async)?.isMobile"
    [ngClass]="{
      'new-content': newContentRoute.includes(currentRoute()),
      content: !newContentRoute.includes(currentRoute()),
    }"
  >
    <ng-container *ngIf="!isSettingsRoute()">
      <div
        class="static-header"
        #navbar
        [class.hide-on-mobile]="
          (mobileHeaderState$ | async)?.hideMainHeader && (sidebarState$ | async)?.isMobile
        "
      >
        <div class="new-navbar">
          <!-- Hamburger menu for mobile -->
          <button
            *ngIf="(sidebarState$ | async)?.isMobile"
            class="hamburger-menu"
            (click)="toggleMobileMenu()"
            aria-label="Toggle menu"
          >
            <i class="pi pi-bars"></i>
          </button>
          <app-navbar [userData]="getUserData()"></app-navbar>
        </div>
        <app-navbar-banner
          [message]="bannerState?.message"
          [icon]="bannerState?.icon"
          [height]="bannerState?.height"
          [width]="bannerState?.width"
        ></app-navbar-banner>
      </div>

      <div
        [ngStyle]="{
          height: navbar?.offsetHeight + 'px',
          position: 'sticky',
        }"
      ></div>
      <div
        [ngStyle]="{
          '--navbar-height': navbar?.offsetHeight + 'px',
        }"
        [ngClass]="{
          'unset-content-wrapper': unsetWrapperRoute.includes(currentRoute()),
          'content-wrapper': !unsetWrapperRoute.includes(currentRoute()),
        }"
      >
        <router-outlet *ngIf="!loading() && !forbiddenPage()"></router-outlet>
        <div *ngIf="forbiddenPage()" class="forbidden-page">
          <div class="forbidden-component col">
            <div style="height: 105px; width: 163px">
              <app-svg-loader [url]="'forbidden-icon.svg'"> </app-svg-loader>
            </div>

            <div class="headline-small">You Do Not Have Access to This Page</div>
            <div style="color: #7a7a7a" class="body-large">
              Access to this page is required. Contact your admin to add this access to your
              account.
            </div>
          </div>
        </div>
        <app-block-loading *ngIf="loading()" [show]="loading()"></app-block-loading>
      </div>
    </ng-container>
    <div
      *ngIf="isSettingsRoute()"
      [ngClass]="{
        'unset-content-wrapper': unsetWrapperRoute.includes(currentRoute()),
        'content-wrapper': !unsetWrapperRoute.includes(currentRoute()),
      }"
    >
      <router-outlet *ngIf="!loading() && !forbiddenPage()"></router-outlet>
      <div *ngIf="forbiddenPage()" class="forbidden-page">
        <div class="forbidden-component col">
          <div style="height: 105px; width: 163px">
            <app-svg-loader [url]="'forbidden-icon.svg'"> </app-svg-loader>
          </div>

          <div class="headline-small">You Do Not Have Access to This Page</div>
          <div style="color: #7a7a7a" class="body-large">
            Access to this page is required. Contact your admin to add this access to your account.
          </div>
        </div>
      </div>
      <app-block-loading *ngIf="loading()" [show]="loading()"></app-block-loading>
    </div>
  </div>
</div>
